// extracted by mini-css-extract-plugin
module.exports = {"pao_mid":"pao_mid-1dJdOICH","box":"box-38A6EaDu","dot":"dot-smDg605I","current":"current-2GXNkwWj dot-smDg605I"};